import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class RateCardQueryCriteriaClass extends BaseCriteriaModel {
  //For bl_pgw_merchant_rate_card table
  guid?: Optional<string> = Optional.empty();
  merchant_contract_guid?: Optional<string> = Optional.empty();
  template_guid?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  hdr_guids?: Optional<string> = Optional.empty(); /** @param hdr_guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //line
  rate_card_guid?: Optional<string> = Optional.empty();
  payment_channel_guid?: Optional<string> = Optional.empty();
  contract_guid?: Optional<string> = Optional.empty();
  line_created_date?: Optional<string> = Optional.empty();
  line_updated_date?: Optional<string> = Optional.empty();
}

export class RateCardCriteriaModelQuery {
  query = '';

  constructor(RateCardCriteriaModel: RateCardQueryCriteriaClass) {
    console.log('RateCardCriteriaModel', RateCardCriteriaModel);

    if (!RateCardCriteriaModel) {
      return;
    }

    this.query += RateCardCriteriaModel.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.merchant_contract_guid.filter(x => x !== '').map(x => '&merchant_contract_guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.template_guid.filter(x => x !== '').map(x => '&template_guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += RateCardCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += RateCardCriteriaModel.hdr_guids.filter(x => x !== '').map(x => '&hdr_guids=' + x).orElse('');

    this.query += RateCardCriteriaModel.rate_card_guid.filter(x => x !== '').map(x => '&rate_card_guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.payment_channel_guid.filter(x => x !== '').map(x => '&payment_channel_guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.contract_guid.filter(x => x !== '').map(x => '&contract_guid=' + x).orElse('');
    this.query += RateCardCriteriaModel.line_created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += RateCardCriteriaModel.line_updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');

    this.query += '&status=' + RateCardCriteriaModel.status;
    this.query += '&orderBy=' + RateCardCriteriaModel.orderBy;
    this.query += '&order=' + RateCardCriteriaModel.order;
    this.query += '&offset=' + RateCardCriteriaModel.offset + '&limit=' + RateCardCriteriaModel.limit;
  }

}
